import axios from 'axios'
import { useDiamondFilterState } from 'context/diamondFilterContext'
import { useEffect, useState } from 'react'
import { DiamondFilterContextType } from 'types/diamondFilter.types'
import { useDiamondData } from 'context/diamondFilterContext'
import { DiamondDataContextType } from 'types/diamondFilter.types'
import { IDiamond } from 'types/diamond.types'
import { isEqual } from 'lodash'
import LoaderProgressBar from '../LoaderProgressBar/LoaderProgressBar'
import diamondDescriptions from './diamondDescriptions.json'
import { useShapeFilter } from 'context/shapeFilterContext';


const formatShape = (shape: string): string => {
  const shapes = {
    RB: 'Round',
    SQCUS: 'Square Cushion',
    CUS: 'Cushion',
    OV: 'Oval',
    PS: 'Pear',
    PR: 'Princess',
    RAD: 'Radiant',
    SQR: 'Square Radiant',
    EC: 'Emerald',
    AS: 'Asscher',
    HS: 'Heart',
    MQ: 'Marquise',
  }

  return shapes[shape as keyof typeof shapes]
}

const TotalDiamondCount = ({ className }: { className?: string }) => {
  const { diamondFilterState } =
    useDiamondFilterState() as DiamondFilterContextType
  const { selectedCushionType } = useShapeFilter();
  const [total, setTotal] = useState<number | undefined | null>(undefined)
  const [totalPerShape, setTotalPerShape] = useState<number | undefined | null>(
    undefined
  )
  const { diamondData } = useDiamondData() as DiamondDataContextType
  const [initialDiamondData, setInitialDiamondData] = useState<IDiamond[]>([])
  const [loader, setLoader] = useState(false)
  const [initialDiamondFilterState, setInitialDiamondFilterState] =
    useState(diamondFilterState)
  useEffect(() => {
    if (diamondData && diamondFilterState) {
      if (
        !isEqual(initialDiamondFilterState, diamondFilterState) &&
        diamondData === initialDiamondData
      ) {
        setLoader(true)
      } else {
        setLoader(false)
        setInitialDiamondFilterState(diamondFilterState)
        setInitialDiamondData(diamondData as IDiamond[])
      }
    } else {
      setLoader(false)
    }
  }, [
    diamondFilterState,
    initialDiamondData,
    initialDiamondFilterState,
    diamondData,
  ])
  useEffect(() => {
    if (diamondData) {
      setInitialDiamondData(diamondData)
    }
  }, [diamondData])
  useEffect(() => {
    const getDiamondCount = async (
      diamondShape: string,
      diamondType: string
    ) => {
      try {
        const response = await axios.get<{
          total: number
          totalPerShape: number
        }>('/api/spree/v1/diamonds/totalCount', {
          params: { shape: diamondShape, type: diamondType },
        })
        const { data } = response
        setTotal(data.total)
        setTotalPerShape(data.totalPerShape)
      } catch (error) {
        console.error(error)
        setTotal(null)
        setTotalPerShape(null)
      }
    }
    getDiamondCount(
      diamondFilterState.shape,
      diamondFilterState.labCreated ? 'lab' : 'natural'
    )
  }, [diamondFilterState.shape, diamondFilterState.labCreated])

  const getDiamondTitle = () => {
    if (diamondFilterState.shape === 'CUS') {
      if (selectedCushionType === 'SQCUS') {
        return 'Square Cushion';
      } else if (selectedCushionType === 'ELCUS') {
        return 'Elongated Cushion';
      }
    }
    return formatShape(diamondFilterState.shape); 
  };

  return (
    <div className={className}>
      {loader ? (
        <LoaderProgressBar />
      ) : (
        <>
          <div className="flex flex-wrap items-end gap-1.5 mb-2.5">
            <h1 className="capitalize font-heading md:font-['Lato'] font-normal md:font-bold text-2xl">
              {`${getDiamondTitle()} ${
                diamondFilterState.labCreated ? 'Lab' : 'Natural'
              } Diamond`}
            </h1>
            {total && totalPerShape && (
              <span className="text-sm text-gray-dark pb-1">{`(${totalPerShape.toLocaleString()} of ${total.toLocaleString()})`}</span>
            )}
          </div>
          {diamondDescriptions.map((data) => {
            if (data.shape === diamondFilterState.shape) {
              return (
                <p key={data.shape} className="text-primary">
                  {data.description}
                </p>
              )
            }
          })}
        </>
      )}
    </div>
  )
}

export default TotalDiamondCount
